module.exports = __webpack_public_path__ + "static/img/norecord.fdce2a8.png";